import React from 'react';
import ReactDOM from 'react-dom/client';
import './utils/logging/disableConsole';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorker';
import { isAdminHost } from './admin-panel/config/adminHost';
import Root from './Root';

function dropControllingServiceWorker() {
  serviceWorkerRegistration.unregister().then(() => {
    if (navigator.serviceWorker && navigator.serviceWorker.controller) {
      window.location.reload();
    }
  });
}

// In development, unregister any existing service worker immediately so it doesn't
// serve a stale cached bundle (which can cause white screen in normal profile; incognito works because it has no SW).
// The admin host does the same in production: a precached shell was painting the
// public coming soon page until the cache caught up after several refreshes.
if ((process.env.NODE_ENV === 'development' || isAdminHost()) && 'serviceWorker' in navigator) {
  dropControllingServiceWorker();
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>
);

// Register service worker for PWA functionality (production only; see serviceWorker.js).
// The admin panel host stays on the network so a stale shell cannot cover it.
if (!isAdminHost()) {
  serviceWorkerRegistration.register({
    onUpdate: registration => {
      const waitingServiceWorker = registration.waiting;

      if (waitingServiceWorker) {
        // Skip the waiting phase and activate the new service worker immediately
        waitingServiceWorker.postMessage({ type: "SKIP_WAITING" });
      }
    }
  });
}

reportWebVitals();